import {Link} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import {RowFlexContainer} from '../FlexComponents'
import * as React from 'react'
import {Colors} from '../Constants'
import {LinkProps} from '@mui/material/Link/Link'

export const StyledLink = (props: LinkProps & { to?: string, disabled?: boolean }) => {
    const {to, disabled, ...rest} = props
    const href = props.to || props.href
    const linkContent = <RowFlexContainer>{props.children}</RowFlexContainer>
    const divProps = rest as React.HTMLAttributes<HTMLDivElement>
    return disabled
        ? (
            <div {...divProps} onClick={() => {
            }}>
            {linkContent}
        </div>
        ) : (
            <Link {...rest} href={href} component={href ? 'a' : 'button'} variant={'body2'}
                type={href ? undefined : 'button'}
                underline="hover"
        >
            {linkContent}
            </Link>)
}

export const InlineLink = withStyles({
    root: {
        color: Colors.Primary,
    }
})(Link)
